import React from 'react';
import { Section } from '../ui/Section';
import { Card } from '../ui/Card';
export function Mecanismo() {
  return <Section background="off-white" data-id="element-150">
      <div className="text-center mb-12" data-id="element-151">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-2" data-id="element-152">
          El mecanismo: Sistema 3C
        </h2>
        <p className="text-emerald-700 font-medium italic mb-8" data-id="element-153">
          (simple, repetible, real)
        </p>

        <p className="text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-154">
          Podés tener el menú perfecto y la lista más completa. Pero si no tenés{' '}
          <strong data-id="element-155">Cierre</strong> — Plan B + swaps + mini-prep — la semana se
          cae igual. Eso es lo que este sistema resuelve que ninguna app ni
          dieta resuelve.
        </p>
      </div>

      <div className="space-y-6" data-id="element-156">
        <Card className="p-6 md:p-8 border-l-8 border-l-emerald-500 flex flex-col md:flex-row gap-6 items-start" data-id="element-157">
          <div className="bg-emerald-100 text-emerald-800 font-bold text-2xl w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-158">
            C1
          </div>
          <div data-id="element-159">
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-160">
              Carbo controlado
            </h3>
            <p className="text-stone-600" data-id="element-161">
              Porciones visuales, sin balanza ni calculadora.
            </p>
          </div>
        </Card>

        <Card className="p-6 md:p-8 border-l-8 border-l-emerald-600 flex flex-col md:flex-row gap-6 items-start" data-id="element-162">
          <div className="bg-emerald-100 text-emerald-800 font-bold text-2xl w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-163">
            C2
          </div>
          <div data-id="element-164">
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-165">Combo</h3>
            <p className="text-stone-600" data-id="element-166">
              Carbo + proteína + fibra/verduras (y un poco de grasa). Porque una
              comida que no sostiene, te empuja a picotear después.
            </p>
          </div>
        </Card>

        <Card className="p-6 md:p-8 border-l-8 border-l-emerald-800 flex flex-col md:flex-row gap-6 items-start bg-emerald-50/50" data-id="element-167">
          <div className="bg-emerald-800 text-white font-bold text-2xl w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg" data-id="element-168">
            C3
          </div>
          <div data-id="element-169">
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-170">Cierre</h3>
            <p className="text-stone-600" data-id="element-171">
              Lista por pasillos + mini-prep + plan de emergencia.
              <span className="block mt-2 font-medium text-emerald-800" data-id="element-172">
                Acá es donde la mayoría falla. Acá es donde este PDF te
                sostiene.
              </span>
            </p>
          </div>
        </Card>
      </div>
    </Section>;
}